import initPrecisionModals from 'JsComponents/precision-modals.js';
import ReactWrapper from 'JsComponents/react-wrapper.js';
import FreeGiftModal from '../react/free-gift-modal.js';
import FrequentlyBought from '../react/frequently-bought.js';
import { migrateSection } from '../components/precision-tabs.js';
import CarouselSwiper from '../components/carousel-swiper.js';
import { initTierProgressBar } from '../components/progress-bar.js';
import { initRebuyBundleValidator } from '../components/rebuy-bundle-validator.js';
import { initCartDrawerShim } from '../components/cart-drawer-shim.js';
import { initRebuyCartSync } from '../components/rebuy-cart-sync.js';
import { initRebuyUiDiscount } from '../components/rebuy-ui-discount.js';
import { initRebuyCartProperties } from '../components/rebuy-cart-properties.js';
import initCustomerHubDiscountLabels from '../components/customerhub-discount-labels.js';
import initBlogPostShare from '../components/blog-post-share.js';
import initPopupModal from '../components/popup-modal.js';
import initAnnouncementBar, {
    reloadAnnouncementBar,
    unloadAnnouncementBar,
} from '../components/announcement-bar.js';

// Rebuy Smart Cart mode (set in theme.liquid). When on, Rebuy injects + styles its own cart
// drawer: install the compat shim so the Dawn `<cart-drawer>` API still resolves, skip the theme
// tiered progress bar (Smart Cart renders its own), and skip the Rebuy bundle validator.
//
// The bundle validator's re-add-then-remove reversion (revertSurvivors) was written for the Dawn
// drawer — when no Rebuy Smart Cart is present. In rebuy mode Rebuy Smart Cart reverts broken-bundle
// discounts itself, and the validator instead RACES Rebuy's own cart management on each remove,
// producing a transient burst of extra cart lines (bundle re-added before the tagged lines are
// removed) before it settles. Disable it here and let Rebuy own bundle reversion.
const isRebuySmartCart = window.cartDrawerProvider === 'rebuy';

if (isRebuySmartCart) {
    initCartDrawerShim();
    initRebuyCartSync();
    initRebuyCartProperties();
    initRebuyUiDiscount();
} else {
    initTierProgressBar();
    initRebuyBundleValidator();
}

const initGlobal = () => {
    migrateSection();
    ReactWrapper(FreeGiftModal, '[data-free-gift-modal-container]', '[data-free-gift-modal-props]');
    ReactWrapper(FrequentlyBought, 'frequently-bought', '#frequently-bought-data');
    initPrecisionModals();
    initCustomerHubDiscountLabels();
    initBlogPostShare();
    initAnnouncementBar();
    initPopupModal();
    if (!customElements.get('carousel-swiper')) {
        customElements.define('carousel-swiper', CarouselSwiper);
    }
};

// Run immediately if the DOM is already parsed — the bundle can execute AFTER
// DOMContentLoaded has already fired (cold cache / async load), in which case a plain
// addEventListener('DOMContentLoaded') never fires and the widget mounts only on reload.
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlobal);
} else {
    initGlobal();
}

// Theme editor / cart drawer re-inject section HTML without re-firing DOMContentLoaded.
// Re-mount the FBT widget when a section (re)loads so it doesn't go blank.
document.addEventListener('shopify:section:load', (event) => {
    ReactWrapper(FrequentlyBought, 'frequently-bought', '#frequently-bought-data');
    reloadAnnouncementBar(event.target);
});

// Editing announcement blocks removes the old section node — destroy its Swiper
// so no orphaned autoplay timer keeps ticking against detached DOM.
document.addEventListener('shopify:section:unload', (event) => {
    unloadAnnouncementBar(event.target);
});


